import { render, staticRenderFns } from "./LeftViews.vue?vue&type=template&id=22077769&"
import script from "./LeftViews.vue?vue&type=script&lang=js&"
export * from "./LeftViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports